function mapAnalyticToProprietes(folder, data) {
  mapAnalyticNumberVisitToProprietes(folder, data?.numberVisit);
  mapAnalyticAverageTimePerPageToProprietes(folder, data?.averageTimePerPage);
  mapAnalyticNumberOfPagesToProprietes(folder, data?.numberOfPages);
  return folder;
}
function mapAnalyticNumberVisitToProprietes(folder, data) {
  if (data && Boolean(folder.proprietes) && Array.isArray(folder.proprietes)) {
    folder.proprietes.push({
      nom: "nb_visites",
      valeur: data
    });
  }
  return folder;
}
function mapAnalyticAverageTimePerPageToProprietes(folder, data) {
  if (data && Boolean(folder.proprietes) && Array.isArray(folder.proprietes)) {
    folder.proprietes.push({
      nom: "temps_moyen_par_page",
      valeur: data
    });
  }
  return folder;
}
function mapAnalyticNumberOfPagesToProprietes(folder, data) {
  if (data && Boolean(folder.proprietes) && Array.isArray(folder.proprietes)) {
    folder.proprietes.push({
      nom: "nb_pages",
      valeur: data
    });
  }
  return folder;
}

function updateAnalyticsDataIntoJourneyData(journeyData) {
  journeyData["analytic"] = getAnalyticData();
  return journeyData;
}
function getAnalyticData() {
  const analyticsCookies = [
    { cookieName: "tc_pv_ss", propertyName: "numberOfPages" },
    { cookieName: "tc_vts", propertyName: "numberVisit" },
    { cookieName: "tc_tpp", propertyName: "averageTimePerPage" }
  ];
  let analyticData = {};
  for (const { cookieName, propertyName } of analyticsCookies) {
    const cookieValue = getCookie(cookieName);
    if (cookieValue) {
      analyticData = { ...analyticData, [propertyName]: cookieValue };
    }
  }
  return analyticData;
}
function getCookie(cookieName) {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split("=");
    if (name === cookieName) {
      return decodeURIComponent(value);
    }
  }
  return null;
}

export { getAnalyticData, getCookie, mapAnalyticAverageTimePerPageToProprietes, mapAnalyticNumberOfPagesToProprietes, mapAnalyticNumberVisitToProprietes, mapAnalyticToProprietes, updateAnalyticsDataIntoJourneyData };
